/**
 * Writing sentences around words this deployment chose.
 *
 * Every screen says "store", "inspector" or "zone" by reading them from the client
 * configuration, which means no sentence containing one can be written as a fixed string —
 * and the article in front of it cannot either. Four screens had "a" typed in front of a
 * word supplied at runtime, so a deployment calling its people *inspectors* read "a
 * inspector" on four of its pages.
 *
 * Kept here rather than in one page's file because the mistake is a property of the
 * vocabulary system, not of any screen.
 */

/** "a" or "an", for a word this code does not know in advance. */
export function article(word: string): string {
  return /^[aeiou]/i.test(word) ? 'an' : 'a';
}

/** The word with its article — `withArticle('inspector')` → `"an inspector"`. */
export function withArticle(word: string): string {
  return `${article(word)} ${word}`;
}
